import { createAction, createSlice } from '@reduxjs/toolkit';
import { ACGUserRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface ACGUserState {
    [key: string]: ACGUserRecord;
}

const initialState: ACGUserState = {};

const initialLoadAction = createAction<{ acgUsers: ACGUserState }>('InitialLoad');
const acgUserRecordAction = createAction<ACGUserRecord>(CoreMsgTypes.ACGUserRecord);

const acgUsersSlice = createSlice({
    name: 'acgUsers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => {
                return action.payload.acgUsers;
            })
            .addCase(acgUserRecordAction, (state, action) => {
                if (action.payload.IsDeleted) {
                    delete state[action.payload.ACGUserId];
                } else {
                    state[action.payload.ACGUserId] = action.payload;
                }
            });
    }
});

export default acgUsersSlice.reducer;